import { Component, Vue } from 'vue-property-decorator';
import CustomerModule from '@/store/modules/customer.module';
import RegisteredTagModule from '@/store/modules/registered-tag.module';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { routeName } from '@/constants/route.constants';

const customerModule: CustomerModule = getModule(CustomerModule, store);

const registeredTagModule: RegisteredTagModule = getModule(
  RegisteredTagModule,
  store
);

@Component
export default class PublicCancelMixin extends Vue {
  public async onCancel(): Promise<void> {
    // allow these to go without awaiting
    customerModule.resetStateAction();
    registeredTagModule.resetStateAction();

    this.$router.replace({ name: routeName.public.scan });
  }
}
